import { CustomRoute } from "@router/types";
const routes: Array<CustomRoute> = [
  // 外部账号限制访问的路由只能是 /external 开头的
  {
    path: "/external/login",
    name: "externalLogin",
    component: (): any => import("@/modules/external/pages/login/index.vue"),
    meta: {
      title: "登录",
      hidden: false,
      icon: "tree",
      isNew: true,
      needLogin: false,
    },
  },
  {
    path: "/external/communityList",
    name: "externalCommunityList",
    component: (): any => import("@/modules/external/pages/community/communityList.vue"),
    meta: {
      title: "社区列表",
      hidden: false,
      icon: "tree",
      isNew: true,
      // needLogin: true,
    },
  },
  {
    path: "/external/activityList",
    name: "externalActivityList",
    component: (): any => import("@/modules/external/pages/community/activityList.vue"),
    meta: {
      title: "活动列表",
      hidden: false,
      icon: "tree",
      isNew: true,
      // needLogin: true,
    },
  },
  {
    path: "/external/dataOverview",
    name: "externalDataOverview",
    component: (): any => import("@/modules/external/pages/community/dataOverview.vue"),
    meta: {
      title: "数据概览",
      hidden: false,
      icon: "tree",
      isNew: true,
      // needLogin: true,
    },
  },
  {
    path: "/external/liveStreamFollowerManagement",
    name: "liveStreamFollowerManagement",
    component: (): any => import("@/modules/external/pages/community/liveStreamFollowerManagement.vue"),
    meta: {
      title: "讲堂跟播管理",
      hidden: false,
      icon: "tree",
      isNew: true,
      // needLogin: true,
    },
  },
  {
    path: "/external/articleEdit",
    name: "externalarticleEdit",
    component: (): any => import("@/modules/external/pages/articleEdit/index.vue"),
    meta: {
      title: "文章审订",
      hidden: false,
      icon: "tree",
      isNew: true,
      // needLogin: true,
    },
  },
  {
    path: "/external/videoEdit",
    name: "externalvideoEdit",
    component: (): any => import("@/modules/external/pages/videoEdit/index.vue"),
    meta: {
      title: "视频审订",
      hidden: false,
      icon: "tree",
      isNew: true,
      // needLogin: true,
    },
  },
  {
    path: "/external/coursewareEdit",
    name: "externalcoursewareEdit",
    component: (): any => import("@/modules/external/pages/coursewareEdit/index.vue"),
    meta: {
      title: "课件审订",
      hidden: false,
      icon: "tree",
      isNew: true,
      // needLogin: true,
    },
  },
  {
    path: "/external/pptEdit",
    name: "externalPPTEdit",
    component: (): any => import("@/modules/external/pages/coursewareEdit/index.vue"),
    meta: {
      title: "PPT审订",
      hidden: false,
      icon: "tree",
      isNew: true,
      // needLogin: true,
    },
  },
  {
    path: "/external/liveEdit",
    name: "externalliveEdit",
    component: (): any => import("@/modules/external/pages/liveEdit/index.vue"),
    meta: {
      title: "直播审订",
      hidden: false,
      icon: "tree",
      isNew: true,
      // needLogin: true,
    },
  },
  {
    path: "/external/fillInRoomInfo",
    name: "externalFillInRoomInfo",
    component: (): any => import("@/modules/external/pages/roomInfo/index.vue"),
    meta: {
      title: "直播间数据美化",
      hidden: false,
      icon: "tree",
      isNew: true,
      // needLogin: true,
    },
  },
  {
    path: "/external/beautifyTargetInfo",
    name: "externalBeautifyTargetInfo",
    component: (): any => import("@/modules/external/pages/roomInfo/beautifyTargetInfo.vue"),
    meta: {
      title: "直播间数据美化",
      hidden: false,
      icon: "tree",
      isNew: true,
      // needLogin: true,
    },
  },
  {
    path: "/external/askAndAnswerEdit",
    name: "externalaskAndAnswerEdit",
    component: (): any => import("@/modules/external/pages/askAndAnswerEdit/index.vue"),
    meta: {
      title: "快问快答审订",
      hidden: false,
      icon: "tree",
      isNew: true,
      // needLogin: true,
    },
  },
  {
    path: "/external/healthInterviewEdit",
    name: "externalHealthInterviewEdit",
    component: (): any => import("@/modules/external/pages/healthInterviewEdit/index.vue"),
    meta: {
      title: "科普专访审订",
      hidden: false,
      icon: "tree",
      isNew: true,
      // needLogin: true,
    },
  },
  {
    path: "/external/liveActivityEdit",
    name: "externalLiveActivityEdit",
    component: (): any => import("@/modules/external/pages/liveActivityEdit/index.vue"),
    meta: {
      title: "公益讲堂审订",
      hidden: false,
      icon: "tree",
      isNew: true,
      // needLogin: true,
    },
  },
  {
    path: "/external/medicalMeetActivityEdit",
    name: "externalMedicalMeetActivityEdit",
    component: (): any => import("@/modules/external/pages/medicalMeetActivityEdit/index.vue"),
    meta: {
      title: "医学会议审订",
      hidden: false,
      icon: "tree",
      isNew: true,
      // needLogin: true,
    },
  },
];
export default routes;
